import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ie',
  templateUrl: './ie.component.html',
  styleUrls: ['./ie.component.css']
})
export class IeComponent implements OnInit {

  display: boolean = true;

  constructor() { }

  ngOnInit() {
  }

}
